module.exports = __webpack_public_path__ + "img/bot_bdtd2.910a7541.png";